import * as THREE from 'three';
import {Object3D,Material} from 'three';
import * as TWEEN from "@tweenjs/tween.js";
import {ActionType, EventType} from "../enums";
import {PlayerAnimations} from "./animation";
import {PlayerTwin} from "./twin";
import {AppPlayer} from "../player";

class PlayerEvents {
    animations: PlayerAnimations;
    twin: PlayerTwin;
    player: AppPlayer

    constructor( player: AppPlayer, animations:PlayerAnimations,twin: PlayerTwin ) {
        this.player = player
        this.animations = animations
        this.twin = twin
    }
    execFunc(object: Object3D, event: any){
        switch (event.action) {
            case ActionType.OpenUrl:
                window.open(event.url,"blank");
                break
            case ActionType.OpenAction:
                let target1=this.player.scene.getObjectByProperty('uuid', event.node);
                this.animations.runObjectAnimation(target1, true)
                break;
            case ActionType.StopAction:
                let target2=this.player.scene.getObjectByProperty('uuid', event.node);
                this.animations.stopObjectAnimation(target2)
                break;
            case ActionType.ChangeProperty:
                event.properties.forEach((item:any)=>{
                    // 设置模型属性
                    let target:any=this.player.scene.getObjectByProperty('uuid', item.node);
                    if(target!==null && item.value){
                        if(item.key === "visible"){
                            target[ item.key ] = item.value;
                        }
                        if(item.key === "position"){
                            const newPos = target.position.clone()
                            if (item.value ){
                                newPos.x = item.value.x;
                                newPos.y = item.value.y;
                                newPos.z = item.value.z;
                            }
                            target.position.copy( newPos );
		                    target.updateMatrixWorld( true );
                        }
                        if(item.key === "rotation"){
                            const newPos = target.rotation.clone()
                            if (item.value ){
                                newPos.x = item.value.x;
                                newPos.y = item.value.y;
                                newPos.z = item.value.z;
                            }
                            target.rotation.copy( newPos );
		                    target.updateMatrixWorld( true );
                        }
                        if(item.key === "scale"){
                            const newPos = target.scale.clone()
                            if (item.value ){
                                newPos.x = item.value.x;
                                newPos.y = item.value.y;
                                newPos.z = item.value.z;
                            }
                            target.scale.copy( newPos );
		                    target.updateMatrixWorld( true );
                        }
                        if(item.key === "color" || item.key ==="emissive"){
                            let newColor = parseInt( item.value.substr( 1 ), 16 )
                            let nc
                            if (item.key === 'color'){
                              nc = target.material.color.setHex(newColor)
                            }
                            if (item.key === 'emissive')  {
                              nc = target.material.emissive.setHex(newColor)
                            }
                            this.setMaterialValue(target,item.key,nc)
                        }
                        if(item.key === "opacity"){
                            this.setMaterialValue(target,item.key,item.value)
                        }
                    }
                })
                break;
            case ActionType.HighlightObject:
                let object1=this.player.scene.getObjectByProperty('uuid', event.node);
                this.player.effectComposer.addOutlinePass(object1)
                break;
            case ActionType.NoHighlightObject:
                let object2=this.player.scene.getObjectByProperty('uuid', event.node);
                this.player.effectComposer.deleteOutlinePass(object2)
                break;
            case ActionType.TwinOper:
                if (this.twin && event.twin) {
                    let value = event.twinValue
                    if (event.twin.attr.type === 'struct' || event.twin.attr.type === 'array'){
                        value = JSON.parse(event.twinValue)
                    }
                    if (this.twin.type === "MQTT") {
                        this.twin.sendMsg(JSON.stringify({[event.twin.attrKey] : value}))
                    } else {
                        this.twin.sendMsg(JSON.stringify({
                            "twinId": event.twin.twinId,
                            "attrs": {[event.twin.attrKey] : value}
                        }))
                    }
                }
                break;
            case ActionType.ChangeView:
                const cameraPosition = this.player.camera.position.clone();
                let worldDirection = new THREE.Vector3()
                this.player.camera.getWorldDirection(worldDirection)
                const cameraLookAt = new THREE.Vector3().addVectors(cameraPosition, worldDirection);
                new TWEEN.Tween(cameraPosition)
                    .to(event.view.position, event.view.duration)
                    // tweenjs改变参数对象的过程中，.onUpdate方法会被重复调用执行
                    .onUpdate(function(){
                        this.player.camera.lookAt(cameraLookAt);
                    })
                    .start()
                break;
            case ActionType.FocusObject:
                const tarObg= this.player.scene.getObjectByProperty('uuid',event.node);
                this.player.controls.createCameraTween(event.time || 2000,tarObg)
                break;
        }
    }

    setMaterialValue(object, key, value){
        if (object instanceof THREE.Group){
            object.traverse(function(child) {
              if (child instanceof THREE.Mesh) {
                if (key as String === 'opacity' ){
                  // 判断是否开启transparent
                  if ((child.material instanceof Material) && !child.material.transparent){
                    child.material['transparent'] = true;
                  }
                }
                child.material[ key ] = value;
              }
            });
          }
          if (object instanceof THREE.Mesh) {
            if (key as String === 'opacity' ){
              // 判断是否开启transparent
              if ((object.material instanceof Material) && !object.material.transparent){
                object.material['transparent'] = true;
              }
            }
            object.material[ key ] = value;
          }
    }

    runObjectEvent (object: Object3D,eventType: string){
        if (object.userData === undefined || object.userData === null) {
            return;
        }
        if (object.userData.eventList && Array.isArray(object.userData.eventList)) {
            object.userData.eventList.forEach((event: any) => {
                // 左键事件
                if (event.type === EventType.ClickL && eventType == EventType.ClickL){
                    this.execFunc(object,event)
                }
                // 右键键事件
                if (event.type === EventType.ClickR && eventType == EventType.ClickR){
                    this.execFunc(object,event)
                }
                if (event.type === EventType.DbClick && eventType == EventType.DbClick){
                    this.execFunc(object,event)
                }
                if (event.type === EventType.MoveIn && eventType == EventType.MoveIn){
                    this.execFunc(object,event)
                }
                if (event.type === EventType.MoveOut && eventType == EventType.MoveOut ){
                    this.execFunc(object,event)
                }
                if (event.type === EventType.Chang && eventType == EventType.Chang){
                    this.execFunc(object,event)
                }
                if (event.type === EventType.StartAnimation && eventType == EventType.StartAnimation){
                    this.execFunc(object,event)
                }
                if (event.type === EventType.StopAnimation && eventType == EventType.StopAnimation){
                    this.execFunc(object,event)
                }
            })
        }
    }
}

// openUrl 打开连接
// openAction 触发动画
// stopAction 停止动画
// changeProperty 更改节点属性
// twinOper 孪生操作
// changeView 切换视角
// focusObject 聚焦物体

export interface Event {
    name?: string // 事件名称
    type?: string // 事件类型
    action?: string, // 事件执行动作
    [key: string]: any  // 其他参数
}

export { PlayerEvents };
